import { useTranslation } from 'react-i18next'
import { ConfigurationHeaderWrapper } from '../../_components/configuration-header-wrapper.component'
import { useCurrentProject } from 'src/providers/current-project.provider'
import { ErrorQueryHandler } from 'src/components/error/error-query-handler.component'
import { getTranslatedLabel } from 'src/utils/locale.util'
import { FollowupTimeline } from './_components/followup-timeline.component'
import { CurecallButton, ECurecallButtonAppearance, PlusIcon } from '@honestica/curecall-ui'
import { useLocalizedNavigate } from 'src/hooks/use-localized-navigate'
import { useSortedFollowupTimeline } from './_components/use-sorted-followup-timeline.hook'
import { useParams } from 'react-router-dom'
import { useLocale } from 'src/hooks/use-locale'

export default function ConfigurationFollowupsFollowupIdPage() {
  const { t } = useTranslation()
  const navigate = useLocalizedNavigate()
  const { followupId } = useParams()
  const { locale } = useLocale()
  const { project } = useCurrentProject()
  const { isLoading, error, followupTimeline, timelineMedEventsSorted } = useSortedFollowupTimeline(
    followupId as string,
  )

  if (error) return <ErrorQueryHandler error={error} />
  if (isLoading || !followupTimeline) return <div className="loading" />

  return (
    <ConfigurationHeaderWrapper
      title={t('pages.configuration.followups.manage-followup', {
        followupName: getTranslatedLabel(locale, followupTimeline.intlName),
      })}
      subTitle={t('pages.configuration.followups.description')}
      className="c-flex c-flex-row c-pb-10 c-relative"
    >
      <FollowupTimeline timelineMedEventsSorted={timelineMedEventsSorted} />
      <div className="c-bg-grey-200 c-w-px c-h-full" />
      <div className="c-w-full c-flex c-flex-col c-items-center c-justify-center c-gap-4">
        <CurecallButton
          appearance={ECurecallButtonAppearance['SECONDARY-OUTLINED']}
          iconType={<PlusIcon className="tw-mt-1" />}
          hasIconAtStart
          onClick={() => navigate(`/${project.id}/configuration/followups/${followupId}/chatbot/add`)}
        >
          {t('pages.configuration.followups.add-chatbot')}
        </CurecallButton>
        <CurecallButton
          appearance={ECurecallButtonAppearance['SECONDARY-OUTLINED']}
          iconType={<PlusIcon className="tw-mt-1" />}
          hasIconAtStart
          onClick={() => navigate(`/${project.id}/configuration/followups/${followupId}/messages/add`)}
        >
          {t('pages.configuration.messages.schedule-a-message')}
        </CurecallButton>
      </div>
    </ConfigurationHeaderWrapper>
  )
}
